import { TimerIcon } from "@src/assets/icons";
import { useSwapContext } from "@src/context";

export const DeliveryInfo = () => {
  const { isExpressDeliveryActive } = useSwapContext();

  return (
    <div className="flex items-center">
      <div
        className={`w-4 h-4 mr-1 ${
          isExpressDeliveryActive
            ? "fill-t_success_light"
            : "fill-t_text_primary opacity-50"
        } `}
      >
        <TimerIcon />
      </div>
      <span
        className={`text-xs font-medium sm:text-sm ${
          isExpressDeliveryActive ? "text-t_success_light" : "opacity-50"
        }`}
      >
        {isExpressDeliveryActive ? "Fast ~ 30sec " : "Normal ~ 30min"}
      </span>
    </div>
  );
};
